import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { accountSelectors } from 'store/modules/accounts';
import { userMetricsActions, userMetricsSelectors } from 'store/modules/metrics/user';
interface CommutifiMetrics {
  carbon: number;
  cost: number;
  time: number;
}
interface OrganizationMetricsProviderValue {
  regionScore: number;
  regionMetrics: CommutifiMetrics;
  score: number;
  metrics: CommutifiMetrics;
  isLoading?: boolean;
  fetchMetrics: (orgId: string, params: {
    enterpriseId?: string;
  }) => any;
}
interface OrganizationMetricsProviderProps extends OrganizationMetricsProviderValue {
  children: React.ReactNode;
  organizationId?: string;
  enterpriseId?: string;
}
export const OrganizationMetricsContext = React.createContext<OrganizationMetricsProviderValue | null>(null);
export function OrganizationMetricsProvider(t0) {
  const $ = _c(17);
  const {
    children,
    fetchMetrics,
    metrics,
    regionMetrics,
    score,
    regionScore,
    isLoading,
    organizationId,
    enterpriseId
  } = t0;
  let t1;
  if ($[0] !== enterpriseId || $[1] !== fetchMetrics || $[2] !== organizationId) {
    t1 = () => {
      if (organizationId) {
        fetchMetrics(organizationId, {
          ...(enterpriseId && {
            enterpriseId
          })
        });
      }
    };
    $[0] = enterpriseId;
    $[1] = fetchMetrics;
    $[2] = organizationId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fetchOrgMetricsCallback = t1;
  let t2;
  let t3;
  if ($[4] !== fetchOrgMetricsCallback) {
    t2 = () => {
      fetchOrgMetricsCallback();
    };
    t3 = [fetchOrgMetricsCallback];
    $[4] = fetchOrgMetricsCallback;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== fetchOrgMetricsCallback || $[8] !== isLoading || $[9] !== metrics || $[10] !== regionMetrics || $[11] !== regionScore || $[12] !== score) {
    t4 = {
      isLoading,
      metrics,
      regionMetrics,
      score,
      regionScore,
      fetchMetrics: fetchOrgMetricsCallback
    };
    $[7] = fetchOrgMetricsCallback;
    $[8] = isLoading;
    $[9] = metrics;
    $[10] = regionMetrics;
    $[11] = regionScore;
    $[12] = score;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const value = t4;
  let t5;
  if ($[14] !== children || $[15] !== value) {
    t5 = <OrganizationMetricsContext value={value}>{children}</OrganizationMetricsContext>;
    $[14] = children;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
const mapStateToProps = (state: any) => ({
  currentUserId: accountSelectors.getCurrentId(state),
  metrics: userMetricsSelectors.makeGetConvertedScoreFactors('organization')(state),
  regionMetrics: userMetricsSelectors.makeGetConvertedScoreFactors('region')(state),
  score: userMetricsSelectors.makeGetScore('organization')(state),
  regionScore: userMetricsSelectors.makeGetScore('region')(state),
  isLoading: userMetricsSelectors.getIsFetching(state) || !userMetricsSelectors.getIsLoaded(state)
});
const mapDispatchToProps = {
  fetchMetrics: userMetricsActions.fetchMetricsRequest
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(OrganizationMetricsProvider));
export const OrganizationMetricsConsumer = OrganizationMetricsContext.Consumer;